import type { Theme } from "@mui/material";

export default (theme: Theme) => {
  return {
    page: {
      padding: "1rem",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        height: "auto",
      },
    },
    paper: {
      padding: "1.25rem",
      [theme.breakpoints.down("md")]: {
        boxShadow: "none",
      },
    },
    logoText: {
      position: "absolute",
      left: 0,
      bottom: "-10px",
      display: "block",
      width: "100%",
      fontSize: "10px",
      lineHeight: "10px",
      color: "black",
      letterSpacing: "0.2rem",
      textTransform: "lowercase",
      textAlign: "justify",
      textJustify: "inter-character",
      "&:hover": {
        textDecoration: "none",
      },
    },
    loader: {
      position: "absolute",
      top: "2%",
      left: "2%",
      width: "96%",
      height: "96%",
      backgroundColor: "rgba(255,255,255,0.5)",
      zIndex: 100,
    },
  };
};
